//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../separatorhorCommon.scss'

// @ADD Component types
interface ISeparatorhorCommonLayoutProps {}

const SeparatorhorCommonLayout: React.FC<ISeparatorhorCommonLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='separator-hor'>
    </div>
  )
}

export default SeparatorhorCommonLayout
